import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'
import type { SurveyGrouping as Grouping } from 'app/common/types/surveys'

import styles from './SurveyGrouping.module.scss'


type Props = {
  value: Grouping
  onChange: (value: Grouping) => void
}

const items: Array<{ id: Grouping; title: string }> = [
  { id: 'day', title: 'По дням' },
  { id: 'week', title: 'По неделям' },
  { id: 'month', title: 'По месяцам' },
]

export const SurveyGrouping = ({ value, onChange }: Props) => {
  const handleClick = (grouping: Grouping) => () => onChange(grouping)

  return (
    <div className={styles.root}>
      <span className={styles.label}>{'Показать:'}</span>
      <div className={styles.links}>
        {items.map(item => (
          <PlainButtonAsLink
            key={item.id}
            className={value === item.id ? styles.active : undefined}
            linkClassName={styles.buttonText}
            onClick={handleClick(item.id)}
          >
            {item.title}
          </PlainButtonAsLink>
        ))}
      </div>
    </div>
  )
}
